import React from 'react'

const Main = ({ children }) => (
  <main className='bg-light py-4'>
    <div className='container'>{children}</div>
  </main>
)

export default Main
